"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PropertyInputMultipleEmail = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _react = _interopRequireWildcard(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _reactImmutableProptypes = require("react-immutable-proptypes");

var _uniqueId = _interopRequireDefault(require("transmute/uniqueId"));

var _ReferenceResolverType = _interopRequireDefault(require("reference-resolvers/schema/ReferenceResolverType"));

var _colors = require("HubStyleTokens/colors");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIForm = _interopRequireDefault(require("UIComponents/form/UIForm"));

var _UIFormLabel = _interopRequireDefault(require("UIComponents/form/UIFormLabel"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UITruncateString = _interopRequireDefault(require("UIComponents/text/UITruncateString"));

var _ObjectRecordAccessors = require("customer-data-objects/record/ObjectRecordAccessors");

var _ContactRecord = _interopRequireDefault(require("customer-data-objects/contact/ContactRecord"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _DeleteSecondaryEmailPrompt = _interopRequireDefault(require("customer-data-properties/prompt/DeleteSecondaryEmailPrompt"));

var _PropertyInputMultipleEmailInput = _interopRequireDefault(require("customer-data-properties/input/PropertyInputMultipleEmailInput"));

var _Alerts = require("customer-data-ui-utilities/alerts/Alerts");

var handleError = function handleError(property, error) {
  if (error && error.responseJSON && error.responseJSON.message) {
    return (0, _Alerts.addError)(error.responseJSON.message);
  }

  return (0, _Alerts.addError)('customerDataProperties.PropertyInputMultipleEmail.genericError');
};

var propTypes = {
  actions: _react.PropTypes.shape({
    addSecondaryEmail: _react.PropTypes.func.isRequired,
    deleteSecondaryEmail: _react.PropTypes.func.isRequired,
    promoteEmailToPrimary: _react.PropTypes.func.isRequired,
    updateContactProperties: _react.PropTypes.func.isRequired,
    updateSecondaryEmail: _react.PropTypes.func.isRequired
  }),
  onPrimaryPromoted: _react.PropTypes.func.isRequired,
  onPrimaryPromotedError: _react.PropTypes.func.isRequired,
  onPrimaryUpdated: _react.PropTypes.func.isRequired,
  onPrimaryUpdatedError: _react.PropTypes.func.isRequired,
  onSecondaryAdded: _react.PropTypes.func.isRequired,
  onSecondaryAddedError: _react.PropTypes.func.isRequired,
  onSecondaryDeleted: _react.PropTypes.func.isRequired,
  onSecondaryDeletedError: _react.PropTypes.func.isRequired,
  onSecondaryUpdated: _react.PropTypes.func.isRequired,
  onSecondaryUpdatedError: _react.PropTypes.func.isRequired,
  onTracking: _react.PropTypes.func,
  readOnly: _react.PropTypes.bool.isRequired,
  resolver: _react.PropTypes.oneOfType([(0, _reactImmutableProptypes.mapContains)({
    contacts: _ReferenceResolverType.default.isRequired,
    contactsEmail: _ReferenceResolverType.default.isRequired
  }), _ReferenceResolverType.default]),
  subject: _react.PropTypes.instanceOf(_ContactRecord.default).isRequired,
  subjectId: _react.PropTypes.string,
  value: _react.PropTypes.string.isRequired,
  'data-selenium-test': _react.PropTypes.string
};
var defaultProps = {
  onPrimaryPromoted: _emptyFunction.default,
  onPrimaryPromotedError: handleError,
  onPrimaryUpdated: _emptyFunction.default,
  onSecondaryAdded: _emptyFunction.default,
  onPrimaryUpdatedError: handleError,
  onSecondaryAddedError: handleError,
  onSecondaryDeleted: _emptyFunction.default,
  onSecondaryDeletedError: handleError,
  onSecondaryUpdated: _emptyFunction.default,
  onSecondaryUpdatedError: handleError,
  readOnly: false
};
var DraftEmailRecord = (0, _immutable.Record)({
  value: null,
  isPrimary: false,
  isNewEmail: false
});

var generateId = function generateId() {
  return (0, _uniqueId.default)('new-email');
};

var PropertyInputMultipleEmail =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(PropertyInputMultipleEmail, _PureComponent);

  function PropertyInputMultipleEmail(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PropertyInputMultipleEmail);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputMultipleEmail).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.partial = (0, _ComponentMethods.makePartial)();
    _this.focus = _this.focus.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderEmailInput = _this.renderEmailInput.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      open: false,
      emailDraftValues: _this.getInitialDraftValues(props),
      newEmailsDraft: null
    };
    return _this;
  }

  (0, _createClass2.default)(PropertyInputMultipleEmail, [{
    key: "getInitialDraftValues",
    value: function getInitialDraftValues(props) {
      var value = this.props.value.trim();
      var additionalEmails = (0, _ObjectRecordAccessors.getProperty)(props.subject, 'hs_additional_emails') || '';
      var secondaryEmailValues = (0, _immutable.List)();
      var primaryDraft;

      if (value) {
        primaryDraft = (0, _defineProperty2.default)({}, value, DraftEmailRecord({
          value: value,
          isPrimary: true
        }));
      } else {
        primaryDraft = (0, _defineProperty2.default)({}, generateId, DraftEmailRecord({
          value: '',
          isNewEmail: true,
          isPrimary: true
        }));
      }

      if (additionalEmails.length) {
        secondaryEmailValues = (0, _immutable.List)(additionalEmails.split(';'));
      }

      return secondaryEmailValues.reduce(function (acc, email) {
        if (email === value) {
          return acc;
        }

        return acc.set(email, DraftEmailRecord({
          value: email
        }));
      }, (0, _immutable.Map)(primaryDraft));
    } // called from parent

  }, {
    key: "focus",
    value: function focus() {
      var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.setState({
        open: open
      });

      if (!open) {
        this.setState({
          emailDraftValues: this.getInitialDraftValues(this.props),
          newEmailsDraft: null
        });
      }
    }
  }, {
    key: "getPropertyInputEmailDefaultProps",
    value: function getPropertyInputEmailDefaultProps() {
      return {
        showError: true,
        subjectId: this.props.subjectId,
        onCancel: _emptyFunction.default,
        readOnly: this.props.readOnly
      };
    }
  }, {
    key: "getDraftEmails",
    value: function getDraftEmails() {
      return this.state.emailDraftValues.reduce(function (acc, email) {
        acc.push(email.get('value'));
        return acc;
      }, []);
    }
  }, {
    key: "handleShowPopover",
    value: function handleShowPopover() {
      this.setState({
        open: true
      });
    }
  }, {
    key: "handleEmailDraftChange",
    value: function handleEmailDraftChange(key, value) {
      var draftValue = this.state.emailDraftValues.get(key);
      var nextDraftValue = draftValue.set('value', value);
      var emailDraftValues = this.state.emailDraftValues.set(key, nextDraftValue);
      this.setState({
        emailDraftValues: emailDraftValues
      });
    }
  }, {
    key: "savePrimaryChanges",
    value: function savePrimaryChanges(email, emailToUpdate, nextDraftValues) {
      var _this$props = this.props,
          onPrimaryUpdated = _this$props.onPrimaryUpdated,
          subject = _this$props.subject,
          updateContactProperties = _this$props.actions.updateContactProperties,
          onPrimaryUpdatedError = _this$props.onPrimaryUpdatedError;
      var nextEmailValue = emailToUpdate.get('value'); // contact never had an email value

      if (emailToUpdate.get('isNewEmail')) {
        var nextEmailDraft = emailToUpdate.set('isNewEmail', false);
        nextDraftValues = nextDraftValues.set(nextEmailValue, nextEmailDraft);
      } else {
        nextDraftValues = nextDraftValues.set(nextEmailValue, emailToUpdate);
      }

      updateContactProperties(subject, (0, _immutable.Map)({
        email: nextEmailValue
      }), onPrimaryUpdatedError);
      onPrimaryUpdated();
      this.setState({
        emailDraftValues: nextDraftValues
      });
    }
  }, {
    key: "saveNewEmail",
    value: function saveNewEmail(email, emailToUpdate, nextDraftValues) {
      var _this2 = this;

      var _this$props2 = this.props,
          onSecondaryAdded = _this$props2.onSecondaryAdded,
          onSecondaryAddedError = _this$props2.onSecondaryAddedError,
          subject = _this$props2.subject,
          addSecondaryEmail = _this$props2.actions.addSecondaryEmail;
      var nextEmailValue = emailToUpdate.get('value');
      emailToUpdate = emailToUpdate.set('isNewEmail', false);
      nextDraftValues = nextDraftValues.set(nextEmailValue, emailToUpdate);
      addSecondaryEmail(subject, nextEmailValue).catch(function (error) {
        _this2.setState({
          emailDraftValues: nextDraftValues.delete(nextEmailValue)
        });

        onSecondaryAddedError(null, error);
      });
      this.setState({
        emailDraftValues: nextDraftValues
      });
      onSecondaryAdded();
    }
  }, {
    key: "saveSecondaryChanges",
    value: function saveSecondaryChanges(email, emailToUpdate, nextDraftValues) {
      var _this$props3 = this.props,
          onSecondaryUpdated = _this$props3.onSecondaryUpdated,
          onSecondaryUpdatedError = _this$props3.onSecondaryUpdatedError,
          subject = _this$props3.subject,
          updateSecondaryEmail = _this$props3.actions.updateSecondaryEmail;
      var nextEmailValue = emailToUpdate.get('value');
      nextDraftValues = nextDraftValues.set(nextEmailValue, emailToUpdate);
      updateSecondaryEmail(subject, email, nextEmailValue).catch(function (error) {
        onSecondaryUpdatedError(null, error);
      });
      this.setState({
        emailDraftValues: nextDraftValues
      });
      onSecondaryUpdated();
    }
  }, {
    key: "handleSaveEmailDraftChanges",
    value: function handleSaveEmailDraftChanges(email) {
      var emailDraftValues = this.state.emailDraftValues;
      var emailToUpdate = emailDraftValues.get(email);
      var nextDraftValues = emailDraftValues.delete(email);

      if (emailToUpdate.get('isPrimary')) {
        this.savePrimaryChanges(email, emailToUpdate, nextDraftValues);
      } else if (emailToUpdate.get('isNewEmail')) {
        this.saveNewEmail(email, emailToUpdate, nextDraftValues);
      } else {
        this.saveSecondaryChanges(email, emailToUpdate, nextDraftValues);
      }
    }
  }, {
    key: "handleCancelEmailDraftChanges",
    value: function handleCancelEmailDraftChanges(value) {
      var emailDraftValues = this.state.emailDraftValues;
      var draftEmail = emailDraftValues.get(value);
      var isNewEmail = draftEmail.get('isNewEmail');

      if (isNewEmail) {
        this.setState({
          emailDraftValues: emailDraftValues.delete(value)
        });
        return;
      }

      var updatedDraftEmail = draftEmail.set('value', value);
      this.setState({
        emailDraftValues: emailDraftValues.set(value, updatedDraftEmail)
      });
    }
  }, {
    key: "handlePromoteToPrimary",
    value: function handlePromoteToPrimary(emailToPromote) {
      var _this3 = this;

      var emailDraftValues = this.state.emailDraftValues;
      var _this$props4 = this.props,
          onPrimaryPromoted = _this$props4.onPrimaryPromoted,
          onPrimaryPromotedError = _this$props4.onPrimaryPromotedError,
          subject = _this$props4.subject,
          promoteEmailToPrimary = _this$props4.actions.promoteEmailToPrimary,
          onTracking = _this$props4.onTracking; // handling catch here (and similarly in other save methods here)
      // so we can maintain the order of the drafts on save

      promoteEmailToPrimary(subject, emailToPromote).then(this.partial(onPrimaryPromoted, emailToPromote)).catch(function (error) {
        onPrimaryPromotedError(null, error);

        _this3.setState({
          emailDraftValues: emailDraftValues
        });
      });
      var nextDraftValues = emailDraftValues.map(function (email) {
        var isThisPrimary = emailToPromote === email.value;
        return email.set('isPrimary', isThisPrimary);
      });
      onTracking('changes primary email in multiple email property input');
      return this.setState({
        emailDraftValues: nextDraftValues
      });
    }
  }, {
    key: "handleConfirmDelete",
    value: function handleConfirmDelete(emailToDelete) {
      var _this4 = this;

      var emailDraftValues = this.state.emailDraftValues;
      var _this$props5 = this.props,
          onSecondaryDeleted = _this$props5.onSecondaryDeleted,
          onSecondaryDeletedError = _this$props5.onSecondaryDeletedError,
          subject = _this$props5.subject,
          deleteSecondaryEmail = _this$props5.actions.deleteSecondaryEmail;
      deleteSecondaryEmail(subject, emailToDelete).catch(function (error) {
        onSecondaryDeletedError(null, error);

        _this4.setState({
          emailDraftValues: emailDraftValues
        });
      });
      var nextDraftValues = emailDraftValues.filter(function (email) {
        return email.get('value') !== emailToDelete;
      });
      onSecondaryDeleted();
      return this.setState({
        emailDraftValues: nextDraftValues
      });
    }
  }, {
    key: "handleEmailDelete",
    value: function handleEmailDelete(email) {
      var emailDraftValues = this.state.emailDraftValues;
      var draftEmail = emailDraftValues.get(email);

      if (draftEmail.get('isNewEmail')) {
        var nextDraftValues = emailDraftValues.delete(email);
        this.setState({
          emailDraftValues: nextDraftValues
        });
        return;
      }

      (0, _DeleteSecondaryEmailPrompt.default)(this.partial(this.handleConfirmDelete, email), this.handleRejectDeletePrompt, email);
    }
  }, {
    key: "handleAddNewEmailInput",
    value: function handleAddNewEmailInput() {
      var emailDraftValues = this.state.emailDraftValues;
      var nextDrafts = emailDraftValues.set(generateId(), DraftEmailRecord({
        isNewEmail: true,
        value: ''
      }));
      this.setState({
        emailDraftValues: nextDrafts
      });
    }
  }, {
    key: "renderEmailsForReadOnlyState",
    value: function renderEmailsForReadOnlyState() {
      var value = this.props.value;
      var className = value === ' ' ? 'p-bottom-5' : 'p-top-1';
      var emails = this.getDraftEmails();
      return _react.default.createElement("div", {
        onClick: this.partial(this.focus, !this.state.open),
        className: className,
        "data-selenium-test": this.props['data-selenium-test']
      }, _react.default.createElement(_UITruncateString.default, null, emails.join(_I18n.default.text('customerDataProperties.PropertyInputMultipleEmail.commaSeparatorKey'))));
    }
  }, {
    key: "renderEmailInput",
    value: function renderEmailInput(emailKey) {
      var emailDraftValues = this.state.emailDraftValues;
      var subject = this.props.subject;
      var resolver = this.props.resolver;

      if (_immutable.Map.isMap(resolver)) {
        resolver = resolver.get('contactsEmail');
      }

      return _react.default.createElement(_PropertyInputMultipleEmailInput.default, {
        draftEmails: emailDraftValues,
        key: emailKey,
        onCancel: this.handleCancelEmailDraftChanges,
        onChange: this.handleEmailDraftChange,
        onDelete: this.handleEmailDelete,
        onSave: this.handleSaveEmailDraftChanges,
        promoteToPrimary: this.handlePromoteToPrimary,
        propertyInputEmailDefaultProps: this.getPropertyInputEmailDefaultProps(),
        resolver: resolver,
        subject: subject,
        value: emailKey,
        "data-selenium-test": this.props['data-selenium-test']
      });
    }
  }, {
    key: "renderAddNewEmailButton",
    value: function renderAddNewEmailButton() {
      var disabled = this.props.readOnly;
      return _react.default.createElement(_UIButton.default, {
        use: "transparent",
        onClick: this.handleAddNewEmailInput,
        className: "p-left-0 m-top-3 m-left-0 m-bottom-0",
        disabled: disabled
      }, _react.default.createElement(_UIIcon.default, {
        name: "add",
        size: "xxs",
        color: disabled ? _colors.EERIE : _colors.CALYPSO_DARK
      }), _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "customerDataProperties.PropertyInputMultipleEmail.addEmail"
      }));
    }
  }, {
    key: "renderDisabledAddNewEmailButton",
    value: function renderDisabledAddNewEmailButton() {
      return _react.default.createElement(_UITooltip.default, {
        title: _react.default.createElement(_FormattedHTMLMessage.default, {
          message: "customerDataProperties.PropertyInputMultipleEmail.permissionsAlert.editContact"
        })
      }, this.renderAddNewEmailButton());
    }
  }, {
    key: "renderPopoverBody",
    value: function renderPopoverBody() {
      var emailDraftValues = this.state.emailDraftValues;
      return _react.default.createElement("div", null, _react.default.createElement(_UIForm.default, {
        className: "m-top-0 m-left-4"
      }, _react.default.createElement(_UIGrid.default, null, _react.default.createElement(_UIGridItem.default, {
        size: {
          xs: 10
        },
        className: "p-left-0"
      }, _react.default.createElement(_UIFormLabel.default, null, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "customerDataProperties.PropertyInputMultipleEmail.label"
      }))), _react.default.createElement(_UIGridItem.default, {
        size: {
          xs: 2
        },
        className: "justify-end"
      }, _react.default.createElement(_UIIcon.default, {
        name: "remove",
        size: "xxs",
        color: _colors.EERIE,
        onClick: this.partial(this.focus, false)
      }))), _react.default.createElement("div", {
        className: 'overflow-y-auto overflow-x-hidden ',
        style: {
          maxHeight: '60vh',
          padding: '18px'
        }
      }, emailDraftValues.keySeq().map(this.renderEmailInput))), this.props.readOnly ? this.renderDisabledAddNewEmailButton() : this.renderAddNewEmailButton());
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIGridItem.default, {
        size: {
          xs: 12
        },
        className: "p-x-0"
      }, _react.default.createElement(_UIPopover.default, {
        open: this.state.open,
        closeOnOutsideClick: true,
        content: {
          body: this.renderPopoverBody()
        },
        width: 450,
        className: "p-bottom-4",
        placement: "right",
        autoPlacement: "horiz"
      }, this.renderEmailsForReadOnlyState()));
    }
  }]);
  return PropertyInputMultipleEmail;
}(_PureComponent2.default);

exports.PropertyInputMultipleEmail = PropertyInputMultipleEmail;
PropertyInputMultipleEmail.propTypes = propTypes;
PropertyInputMultipleEmail.defaultProps = defaultProps;
var _default = PropertyInputMultipleEmail;
exports.default = _default;